import { Subscription } from 'rxjs';

import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, OnChanges,
  OnDestroy, OnInit, Output, SimpleChanges, ViewEncapsulation
} from '@angular/core';

import {
  AnimationsEnum, BrandThemesEnum, DeviceService, IconSizeEnum, IExtendedLink, ILinkMedia, ImageRatioEnum, IRichParagraph,
  PositionEnum, SdBannerComponent, SdLibConfig, SdRichParagraphComponent, SdThemeComponent, ThemesEnum
} from '@seb/web-design-system/core';

import { IMiniPushCard } from './mini-push-card.interface';

@Component({
  selector: 'sd-mini-push-card',
  templateUrl: './mini-push-card.component.html',
  styleUrls: ['./mini-push-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdBannerComponent,
    SdRichParagraphComponent
  ]
})
export class SdMiniPushCardComponent extends SdThemeComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  isLoading = false;

  @Input()
  titleLevel = 3;

  @Input()
  contentData: IRichParagraph;

  @Input()
  isDescription = false;

  @Input()
  mediaAsBackground = true;

  @Input()
  push: IMiniPushCard;

  @Input()
  isFit: boolean;

  @Input()
  twicPicsAutoSize = true;

  @Input()
  mediaConfig: PositionEnum;

  @Input()
  themesConfig: ThemesEnum | BrandThemesEnum;

  @Input()
  hasModal = true;

  @Output()
  clicked = new EventEmitter<IExtendedLink | ILinkMedia>();

  @Output() carouselClicked = new EventEmitter<void>();

  @Input()
  class = ''; // override the standard class attr with a new one.

  @HostBinding('class')
  get hostClasses(): string {
    return this.getClasses();
  }

  animation: AnimationsEnum;
  showPushBorder: boolean;
  canApplyRatio = true;
  hasLinks = false;
  _titleLevel: number;
  iconSizeEnum = IconSizeEnum;
  positionEnum = PositionEnum;
  textConfig = PositionEnum;
  imageRatioEnum = ImageRatioEnum;
  isMobile$: boolean;
  mobileSubscription: Subscription;

  constructor(
    private readonly deviceService: DeviceService,
    private readonly sdLibConfig: SdLibConfig,
    private readonly cdRef: ChangeDetectorRef
  ) {
    super();

    const { showPushBorder, animation } = this.sdLibConfig.get();

    this.showPushBorder = showPushBorder;
    this.animation = animation;
  }

  getClasses() {
    return [
      'c__mini-push-card',
      this.class,
      this.mediaConfig ? 'is-' + this.mediaConfig : '',
      this.themesConfig ? 'is-theme-' + this.themesConfig : '',
      this.animation ? 'is-animation-' + this.animation : '',
      this.canApplyRatio ? 'has-ratio' : '',
      this.mediaAsBackground ? 'has-background' : '',
      this.showPushBorder ? 'has-border' : ''
    ].filter(Boolean).join(' ');
  }

  ngOnInit() {
    this.mobileSubscription = this.deviceService.isMobile.subscribe((x) => {
      this.isMobile$ = x;
      this.cdRef.markForCheck();
    });

    if (this.push) {
      this.hasLinks = Object.entries(this.push).filter(
        (data) => data[0] !== 'links').every((x) => x[1] === null || x[1] === ''
      );
    }

    this._titleLevel = this.titleLevel;
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);

    const { showPushBorder, animation } = this.sdLibConfig.get(this.brand);

    this.showPushBorder = showPushBorder;
    this.animation = animation;

    if (this.isDescription) {
      this.titleLevel = 7;
    } else if (!changes.titleLevel) {
      this.titleLevel = this._titleLevel;
    }
  }

  onClick(event: { link: IExtendedLink | ILinkMedia }) {
    this.clicked.emit(event.link);
    this.carouselClicked.emit();
  }

  ngOnDestroy() {
    this.mobileSubscription?.unsubscribe();
  }
}
